import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../services/authentication.service';
import {environment} from '../../environments/environment';
import {ScorecardModel} from "../models/scorecard.model";
import {PaginatedResponse} from "../models/paginated-response";

export interface ScorecardsFilter {
  organizationId?: number;
  terminalId?: number;
  driverId?: number;
  dateFrom?: Date;
  dateTo?: Date;
}

@Injectable()
export class ScorecardDataSource {

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) {
  }

  getScorecards(pageIndex: number,
                pageSize: number,
                filter: ScorecardsFilter): Observable<PaginatedResponse<ScorecardModel>> {

    let params = new HttpParams();
    params = params.append('pageNumber', pageIndex);
    params = params.append('pageSize', pageSize);
    if (filter.organizationId) {
      params = params.append('organizationId', filter.organizationId);
    }
    if (filter.terminalId) {
      params = params.append('terminalId', filter.terminalId);
    }
    if (filter.driverId) {
      params = params.append('driverId', filter.driverId);
    }
    if (filter.dateFrom && filter.dateTo) {
      params = params.append('dateFrom', filter.dateFrom.toUTCString());
      params = params.append('dateTo', filter.dateTo.toUTCString());
    }

    return this.http.get<PaginatedResponse<ScorecardModel>>(
      environment.backendApi + 'api/Scorecard/Find',
      {params: params}
    );
  }
}
